import React, { useEffect, useState } from 'react';
import { CarouselProductOfProductRange } from "~/rs-components/product-range/CarouselProductOfProductRange.client";
import { ProductFilterObject, ResultFilterObject, ShopMetafields } from "~/types";
import { retailSystem, storeCredentials } from "../../../settings";
import axios from 'axios';
import { ProductRangeOfBrand } from '~/rs-components/product-range/ProductRangeOfBrand.client';
import { fetchSync } from '@shopify/hydrogen';
import { useDataCollection } from '~/rs-components/useDataCollection.client';
import { ProductRangeByHandle } from '~/rs-components/product-range/ProductRangeByHandle.client';

interface SetupCustomSectionBelowProps {
    shop: ShopMetafields;
    brand: string;
    productRange: any;
}

export default function SetupCustomSectionBelow({ shop, brand, productRange }: SetupCustomSectionBelowProps) {
    
    return (
        <>
          
        </>
    );
}
